import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMe, useServerHealthCheck } from 'src/hooks'
import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { TrackGoodIcon } from 'src/assets/icons'
import { Box, Typography } from '@mui/material'
import { Loader } from 'src/components'
import { ETranslationNs } from 'src/types'
import { object } from 'prop-types'

const Maintenance = () => {
  const navigate = useNavigate()
  const [t, i18n] = useTranslation()
  const { data, error, isLoading, refetch } = useServerHealthCheck()
  const { data: user, isLoading: isUserLoading, refetch: refetchUser } = useMe()

  // const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      refetch()
    }, 6000)

    const checkRedirect = async () => {
      if (!isLoading && !error && data === 'OK') {
        // i18n.reloadResources(user?.language.code, Object.values(ETranslationNs), () => {
        //   setLoaded(true)
        // })

        const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)

        if (
          user
          // && loaded
        ) {
          await i18n.reloadResources()
          if (user?.accounts?.length === 0) {
            navigate(`/${ROUTES.USER}/${ROUTES.USER_DASHBOARD}`, { replace: true })
          } else {
            navigate(`/${ROUTES.ACCOUNTS}`, { replace: true })
          }
        } else if (
          !isUserLoading &&
          !token
          // && loaded
        ) {
          await i18n.reloadResources()
          navigate(`/${ROUTES.USER}/${ROUTES.USER_DASHBOARD}`, { replace: true })
        }
        refetchUser()
      }
    }

    checkRedirect()

    return () => clearInterval(interval)
  }, [data, error, isLoading, isUserLoading, user])

  return (
    // <Loader />
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        p: '16px',
        gap: '16px',
      }}
    >
      <TrackGoodIcon width="auto" height="60" />

      <Typography variant="h4" sx={{ textAlign: 'center' }}>
        Server Temporarily Unavailable
      </Typography>
      <Typography variant="body1">We'll be back shortly.</Typography>
    </Box>
  )
}

export default Maintenance
